import { ABOUT, CV_URL } from "@/data/site";
import { MaskedLines, Reveal } from "@/components/site/Motion";

const Row = ({ label, children, testId }) => (
  <div className="grid grid-cols-1 gap-4 border-t border-ink/15 py-10 md:grid-cols-12 lg:py-14" data-testid={testId}>
    <h3 className="label text-mute md:col-span-3">{label}</h3>
    <div className="md:col-span-9">{children}</div>
  </div>
);

const Experience = () => (
  <ul className="divide-y divide-ink/15">
    {ABOUT.experience.map((x) => (
      <li key={x.id} className="grid grid-cols-1 gap-3 py-6 first:pt-0 last:pb-0 lg:grid-cols-9 lg:gap-8" data-testid={`experience-${x.id}`}>
        <div className="lg:col-span-4">
          <p className="font-display text-2xl font-medium tracking-[-0.03em]">{x.org}</p>
          <p className="mt-1 text-mute">{x.role} — {x.place}</p>
          <p className="label mt-3 text-ink">{x.date} · {x.kind}</p>
        </div>
        <p className="leading-relaxed text-ink/85 lg:col-span-5">{x.text}</p>
      </li>
    ))}
  </ul>
);

const Skills = () => (
  <div className="grid grid-cols-1 gap-8 sm:grid-cols-2">
    {Object.entries(ABOUT.skills).map(([group, items]) => (
      <div key={group}>
        <p className="mb-4 text-sm text-mute">{group}</p>
        <ul className="space-y-1.5 font-display text-xl tracking-[-0.02em] lg:text-2xl">
          {items.map((s) => <li key={s}>{s}</li>)}
        </ul>
      </div>
    ))}
  </div>
);

export const About = () => (
  <section id="about" data-testid="about-section" aria-labelledby="about-title" className="px-6 py-24 lg:px-12 lg:py-36">
    <div className="grid grid-cols-1 gap-10 md:grid-cols-12">
      <p className="label text-mute md:col-span-3">(02) About</p>
      <div className="md:col-span-9">
        <h2 id="about-title" className="font-display text-4xl font-medium leading-[0.98] tracking-[-0.045em] sm:text-5xl lg:text-[5.25rem]">
          <MaskedLines inView lines={ABOUT.headline} />
        </h2>
        <Reveal className="mt-12 grid grid-cols-1 gap-6 text-lg leading-relaxed lg:mt-16 lg:grid-cols-2 lg:gap-10">
          {ABOUT.copy.map((c) => <p key={c.slice(0, 20)}>{c}</p>)}
        </Reveal>
        <Reveal className="mt-10">
          <a href={CV_URL} target="_blank" rel="noopener noreferrer" download data-testid="download-cv-link" className="group inline-flex items-center gap-4 border border-ink px-6 py-4 text-sm font-medium transition-colors duration-500 hover:bg-ink hover:text-paper">
            Download CV (PDF)
            <span className="transition-transform duration-500 group-hover:translate-y-0.5" aria-hidden="true">↓</span>
          </a>
          <p className="label mt-3 text-mute">PDF · 1 page</p>
        </Reveal>
      </div>
    </div>
    <div className="mt-20 lg:mt-28">
      <Row label="Experience" testId="about-experience"><Experience /></Row>
      <Row label="Skills" testId="about-skills"><Skills /></Row>
      <Row label="Education" testId="about-education">
        <p className="font-display text-2xl font-medium tracking-[-0.03em]">{ABOUT.education.school}</p>
        <p className="mt-1 text-mute">{ABOUT.education.course} — {ABOUT.education.year}</p>
      </Row>
    </div>
  </section>
);
